export function getImage(path) {
  const mediaURL = global.MEDIA_URL || process.env.VUE_APP_BASE_URL;

  if (mediaURL) {
    return `${mediaURL}${path}`;
  }

  return null;
}
